import { render, staticRenderFns } from "./component.vue?vue&type=template&id=7f704f4e&scoped=true&"
import script from "./component.vue?vue&type=script&lang=js&"
export * from "./component.vue?vue&type=script&lang=js&"
import style0 from "./component.vue?vue&type=style&index=0&id=7f704f4e&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7f704f4e",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/projects/pes-portal/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('7f704f4e')) {
      api.createRecord('7f704f4e', component.options)
    } else {
      api.reload('7f704f4e', component.options)
    }
    module.hot.accept("./component.vue?vue&type=template&id=7f704f4e&scoped=true&", function () {
      api.rerender('7f704f4e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/app/resource/component/file/icon/component.vue"
export default component.exports